import auth from '@/auth'

let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/camanage',
        name: 'camanage',
        component: resolve => require(['@/views/camanage/index'], resolve),
        meta: {
          title: 'CA管理',
          breadLevel: 0,
          icon: 'icon-ca',
          auth: auth.camanage
        }
      }
    ]
  }
]

export default routes
